import { render, staticRenderFns } from "./FeedbackResultsTable.vue?vue&type=template&id=613e3014&scoped=true"
import script from "./FeedbackResultsTable.vue?vue&type=script&lang=js"
export * from "./FeedbackResultsTable.vue?vue&type=script&lang=js"
import style0 from "./FeedbackResultsTable.vue?vue&type=style&index=0&id=613e3014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613e3014",
  null
  
)

export default component.exports